<template>
  <BarChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    :card-options="cardOptions"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import BarChart from '@/components/cards/models/BarChart';
import blipModel from '@/mixins/blip-model';
import { mapActions } from 'vuex';

export default {
  name: 'BlipConversionFunnel',
  components: {
    BarChart,
  },
  mixins: [
    blipModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    servicePath: {
      type: String,
      required: true,
    },
    hideNull: {
      type: Boolean,
      default: false,
    },
    stackLabels: {
      type: [Boolean, String],
      default: true,
    },
  },
  data() {
    return {
      rawData: [],
      requestStatus: 'loading',
      cardOptions: {
        yAxis: {
          stackLabels: {
            enabled: Boolean(this.stackLabels),
            ...(this.stackLabels === 'percentage'
              ? { formatter: (component => {
                return function() {
                  return `${component.sumSeries
                    ? ((this.total / component.sumSeries) * 100).toFixed(1)
                    : 0}%`;
                };
              })(this) }
              : null),
          },
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
          },
        },
      },
    };
  },
  computed: {
    series() {
      const data = [...this.rawData];

      const rawSeries = this.normalizeBlipFromPoints(data, this.hideNull);

      return rawSeries;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipService',
      'hasNoBlipBotAndContractFiltered',
      'getAppliedCardFilter',
    ]),
    async getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (await this.hasNoBlipBotAndContractFiltered(this.itemId)) {
        this.requestStatus = 'emptyBot';
        this.items = [];
        return;
      }

      const cardFilters = await this.getAppliedCardFilter(this.itemId);

      this.getBlipService({
        servicePath: this.servicePath,
        itemId: this.itemId,
        scheduled: cardFilters?.scheduled?.value === undefined ? false : cardFilters?.scheduled?.value,
        campaignName: cardFilters?.campaign_name?.value,
      })
        .then((responses) => {
          if (!options?.silentRefresh) {
            this.requestStatus = 'loading';
          }
          this.rawData = responses;

          if (this.rawData.status === 'failure') {
            this.requestStatus = 'error';
            this.items = [];
            return;
          }

          if (this.verifyItemsNull(this.rawData)) {
            this.requestStatus = 'emptyData';
            this.items = [];
            return;
          }

          this.rawData = this.filterItemsNull(this.rawData);

          const filteredSeries = this.rawData.map(item => ({
            resource: {
              items: item.resource.items.filter(item => item.created),
            },
          }));

          this.rawData = this.getMetricsFromActiveCampaign(filteredSeries);

          this.requestStatus = 'success';
        })
        .catch(error => {
          console.error(error);
          this.items = [];
          this.requestStatus = error.message;
        });
    },

  },
};
</script>

<style lang="scss" scoped>

.v-select__selection.v-select__selection--comma {
  line-height: 120%;
}

.internal-style {
  width: 100%;
  display: flex;
}

.buttons {
  display: grid;
}

.clean-sla-buttons {
  box-shadow: none;
  border-radius: unset;
}

.close-button {
  display: flex;
  flex: end;
  justify-content: flex-end;
}

::v-deep {
  .table-truncate {
    td {
      max-width: 10vw;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .modal-style {
    * {
      color: var(--ds-color-snow) !important;
    }

    h3 {
      font-weight: var(--ds-font-weight-bold);
    }
  }
}
</style>
